/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBase {
    getFixupPrototypeFunction() { return MasterAccountBase.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBase>): MasterAccountBase {
        let obj = Object.assign(new MasterAccountBase(), model);
        MasterAccountBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBase>): MasterAccountBase {
        if (!model) return null;
        return MasterAccountBase.newInstance(<MasterAccountBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBase) {
        if (!obj) return;

        models.MasterAccountBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBase): boolean {
        Object.setPrototypeOf(obj, MasterAccountBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.priority === undefined) {
            this.priority = 0;
        }
        if (this.subscription_info) {
            models.MasterAccountSubscription.fixupPrototype(this.subscription_info);
        }
        if (this.notification_settings) {
            models.MasterAccountNotificationSetting.fixupPrototype(this.notification_settings);
        }
        if (this.fiscal_year_configuration) {
            models.FiscalYearConfiguration.fixupPrototype(this.fiscal_year_configuration);
        }
        if (this.custom_tags) {
            for (let val of this.custom_tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Master account name
     */
    name: string;

    /**
     * Subscription Info
     */
    subscription_info: models.MasterAccountSubscription;

    /**
     * Notification settings
     */
    notification_settings: models.MasterAccountNotificationSetting;

    /**
     * Fiscal Year settings
     */
    fiscal_year_configuration: models.FiscalYearConfiguration;

    /**
     * CRM id
     */
    crm_id: string;

    /**
     * Flag to enable MFA for the master account
     */
    mfa_enabled: boolean;

    /**
     * Flag to enable T-2 cutoff budget cost calculation for the master account. When enabled, budget actual cost for the current period is calculated through 2 days ago instead of through now, to avoid counting cost data the billing provider has not finished syncing.
     */
    budget_cost_t2_enabled: boolean;

    /**
     * List of tag key/value pairs
     */
    custom_tags: Array<models.KeyValuePair>;

    /**
     * Hierarchy level
     */
    hierarchy_level: string;

    /**
     * ID of the parent master account.
     */
    parent_master_account_id: string;

    /**
     * Products
     */
    products: Array<string>;

    /**
     * Flag to set API keys generation is allowed or not for the users of this master account.
     */
    require_access_key: boolean;

    /**
     * Priority of the master account.
     */
    priority: number;

}
